import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import paymentImageFirst from '../images/payment-img-1.png';
import paymentImageSecond from '../images/payment-img-2.png';
import paymentImageThird from '../images/payment-img-3.png';

import css from './SectionPayment.module.css';

const paymentItem = (title, image) => {
  return (
    <div className={css.payment}>
      <img className={css.paymentImage} src={image} alt={title} />
      <h4 className={css.paymentTitle}>{title}</h4>
    </div>
  );
};

const SectionPayment = props => {
  const { className, rootClassName, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.payments}>
        {paymentItem(
          intl.formatMessage({
            id: 'LandingPage.SectionPayment.payment1Title',
          }),
          paymentImageFirst
        )}
        {paymentItem(
          intl.formatMessage({
            id: 'LandingPage.SectionPayment.payment2Title',
          }),
          paymentImageSecond
        )}
        {paymentItem(
          intl.formatMessage({
            id: 'LandingPage.SectionPayment.payment3Title',
          }),
          paymentImageThird
        )}
      </div>
    </div>
  );
};

const { string } = PropTypes;

SectionPayment.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionPayment.propTypes = {
  className: string,
  rootClassName: string,
};

export default SectionPayment;
